import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import {
  CustomFormattedMessage,
  TranslationsKeys,
  useCustomIntl,
} from '../../../../i18n/i18n';

type DashboardFunctionsSection = {
  text: TranslationsKeys;
  image: string;
  imageAlt: TranslationsKeys;
};

export const DashboardDashboardFunctionsChapter: React.FC = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();

  const headlineImage = getImageAssetWithLocale(
    imageKeys.dashboardDashboardFunctionsHeadline,
    locale,
  );

  const sections: DashboardFunctionsSection[] = [
    {
      text: 'userManual.getStarted.overview.quickActions.text',
      image: getImageAssetWithLocale(
        imageKeys.dashboardDashboardFunctions1,
        locale,
      ),
      imageAlt: 'dashboard.panels.vehicleInformation.header',
    },
    {
      text: 'userManual.getStarted.overview.insights.text',
      image: getImageAssetWithLocale(
        imageKeys.dashboardDashboardFunctions2,
        locale,
      ),
      imageAlt: 'dashboard.panels.vehicleInformation.header',
    },
    {
      text: 'userManual.getStarted.overview.partners.text',
      image: getImageAssetWithLocale(
        imageKeys.dashboardDashboardFunctions3,
        locale,
      ),
      imageAlt: 'dashboard.panels.vehicleInformation.header',
    },
    {
      text: 'userManual.getStarted.overview.resources.text',
      image: getImageAssetWithLocale(
        imageKeys.dashboardDashboardFunctions4,
        locale,
      ),
      imageAlt: 'dashboard.panels.vehicleInformation.header',
    },
    {
      text: 'userManual.getStarted.overview.resources.text',
      image: getImageAssetWithLocale(
        imageKeys.dashboardDashboardFunctions5,
        locale,
      ),
      imageAlt: 'dashboard.panels.vehicleInformation.header',
    },
    {
      text: 'userManual.getStarted.overview.resources.text',
      image: getImageAssetWithLocale(
        imageKeys.dashboardDashboardFunctions6,
        locale,
      ),
      imageAlt: 'dashboard.panels.vehicleInformation.header',
    },
    {
      text: 'userManual.getStarted.overview.resources.text',
      image: getImageAssetWithLocale(
        imageKeys.dashboardDashboardFunctions7,
        locale,
      ),
      imageAlt: 'dashboard.panels.vehicleInformation.header',
    },
  ];

  return (
    <div>
      <div className={'row col-xs-12'}>
        <ChapterHeadline
          messageId={'userManual.chapter.dashboard.dashboardFunctions.headline'}
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            colSize={12}
            colSizeMd={6}
            messageId={'userManual.chapter.dashboard.dashboardFunctions.text'}
          />
          <div className="col-xs-12 col-md-6 margin-bottom-25">
            <ImageLoader
              src={headlineImage}
              className={'border'}
              alt={formatMessage({
                id: 'userManual.chapter.dashboard.dashboardFunctions.headline',
              })}
              enlargeable
            />
          </div>
        </div>
      </div>
      <div className={'row margin-top-20'}>
        <div className={'col-xs-12 margin-bottom-10'}>
          <CustomFormattedMessage id="userManual.chapter.dashboard.dashboardFunctions.functionsTitle" />
        </div>
        {sections.map((section, index) => (
          <div
            key={index}
            className={
              'col-xs-12 display-flex margin-top-10 margin-bottom-20 flex-column gap-25 flex-row-ls'
            }
          >
            <div className={'col-xs-12 col-ls-7 col-md-6'}>
              <li className="margin-left-15">
                <CustomFormattedMessage id={section.text} />
              </li>
            </div>
            <div className={'col-xs-12 col-ls-5 col-md-6'}>
              <ImageLoader
                className="max-width-100pct-xs max-width-60pct-md border"
                src={section.image}
                alt={formatMessage({ id: section.imageAlt })}
                enlargeable
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
